export default __webpack_public_path__ + "static/media/notification.d4ff27a0.svg";